/**
 * I18N-C3-C1 — Sheet24 finite exact-string localization.
 *
 * GENERATED FROM THE AUTHORITATIVE V2.9.9 Sheet24 runtime inventory.
 *
 * Presentation only.
 *
 * Guarantees:
 * - Field-aware exact whole-string lookup only.
 * - No parsing, splitting, normalization, regex, substring replacement,
 *   number-array conversion, or inference.
 * - Never imports engine / DB mirrors / storage / migration / adapter.
 * - zh returns canonical source values verbatim.
 * - en translates only exact audited canonical values.
 * - Unknown field/value falls back to canonical verbatim.
 * - C11 lifeNumberRaw is intentionally outside this catalog and remains
 *   numeric passthrough.
 * - C7 / E12 / G18 / A45 / A51 are intentionally outside C3-C1.
 */

const EN_BY_FIELD = Object.freeze({
  "elementMeaning": Object.freeze({
    "—｜—": "— | —",
    "火｜表达、行动、能见度": "Fire | Expression, action, and visibility",
    "金｜规则、判断、执行": "Metal | Rules, judgment, and execution",
    "木｜成长、规划、延展": "Wood | Growth, planning, and expansion",
    "水｜流动、连接、洞察": "Water | Flow, connection, and insight",
    "土｜稳定、承载、长期积累": "Earth | Stability, support, and long-term accumulation",
  }),
  "lifeNumberElement": Object.freeze({
    "火": "Fire",
    "金": "Metal",
    "木": "Wood",
    "水": "Water",
    "土": "Earth",
  }),
  "lifeNumberSummary": Object.freeze({
    "生命数字 1 属水": "Life Number 1 belongs to Water.",
    "生命数字 2 属土": "Life Number 2 belongs to Earth.",
    "生命数字 3 属木": "Life Number 3 belongs to Wood.",
    "生命数字 4 属木": "Life Number 4 belongs to Wood.",
    "生命数字 5 属土": "Life Number 5 belongs to Earth.",
    "生命数字 6 属金": "Life Number 6 belongs to Metal.",
    "生命数字 7 属金": "Life Number 7 belongs to Metal.",
    "生命数字 8 属土": "Life Number 8 belongs to Earth.",
    "生命数字 9 属火": "Life Number 9 belongs to Fire.",
  }),
  "overallRelation": Object.freeze({
    "生命数字可支持补强方向。": "The Life Number provides generative support to the strengthening direction.",
    "生命数字与补强方向属中性搭配。": "The Life Number has a neutral relationship with the strengthening direction.",
    "生命数字与补强方向一致。": "The Life Number aligns with the strengthening direction.",
    "生命数字与少用五行重叠，需要平衡使用。": "The Life Number overlaps with the reduced-use element and should be used in balance.",
  }),
  "boundaryHint": Object.freeze({
    "生命数字可作个人锚点；仍以核心多用号码为主。": "The Life Number can serve as a personal anchor; the core numbers remain the primary preference.",
    "生命数字与少用五行重叠：保留1位即可，避免连续重复。": "The Life Number overlaps with the reduced-use element: keep one occurrence if desired and avoid consecutive repetition.",
  }),
  "coreNumbersBlock": Object.freeze({
    "—\n（—）": "—\n(—)",
    "1\n（水）": "1\n(Water)",
    "2、5、8\n（土）": "2、5、8\n(Earth)",
    "3、4\n（木）": "3、4\n(Wood)",
    "6、7\n（金）": "6、7\n(Metal)",
    "9\n（火）": "9\n(Fire)",
  }),
  "auxNumbersBlock": Object.freeze({
    "—\n（—生—）": "—\n(— generates —)",
    "1\n（水生木）": "1\n(Water generates Wood)",
    "2、5、8\n（土生金）": "2、5、8\n(Earth generates Metal)",
    "3、4\n（木生火）": "3、4\n(Wood generates Fire)",
    "6、7\n（金生水）": "6、7\n(Metal generates Water)",
    "9\n（火生土）": "9\n(Fire generates Earth)",
  }),
  "lifeNumberBlock": Object.freeze({
    "1\n（水）": "1\n(Water)",
    "2\n（土）": "2\n(Earth)",
    "3\n（木）": "3\n(Wood)",
    "4\n（木）": "4\n(Wood)",
    "5\n（土）": "5\n(Earth)",
    "6\n（金）": "6\n(Metal)",
    "7\n（金）": "7\n(Metal)",
    "8\n（土）": "8\n(Earth)",
    "9\n（火）": "9\n(Fire)",
  }),
  "priorityOrder": Object.freeze({
    "— 为核心多用；— 为辅助。": "— as the primary numbers; — as supporting numbers.",
    "1 为核心多用；6、7 为辅助。": "1 as the primary numbers; 6、7 as supporting numbers.",
    "2、5、8 为核心多用；9 为辅助。": "2、5、8 as the primary numbers; 9 as supporting numbers.",
    "3、4 为核心多用；1 为辅助。": "3、4 as the primary numbers; 1 as supporting numbers.",
    "6、7 为核心多用；2、5、8 为辅助。": "6、7 as the primary numbers; 2、5、8 as supporting numbers.",
    "9 为核心多用；3、4 为辅助。": "9 as the primary numbers; 3、4 as supporting numbers.",
  }),
  "reinforcementLogic": Object.freeze({
    "—生—：号码 — 用于辅助核心号码。": "— generates —: numbers — support the core numbers.",
    "火生土：号码 9 用于辅助核心号码。": "Fire generates Earth: numbers 9 support the core numbers.",
    "金生水：号码 6、7 用于辅助核心号码。": "Metal generates Water: numbers 6、7 support the core numbers.",
    "木生火：号码 3、4 用于辅助核心号码。": "Wood generates Fire: numbers 3、4 support the core numbers.",
    "水生木：号码 1 用于辅助核心号码。": "Water generates Wood: numbers 1 support the core numbers.",
    "土生金：号码 2、5、8 用于辅助核心号码。": "Earth generates Metal: numbers 2、5、8 support the core numbers.",
  }),
  "lifeNumberUsage": Object.freeze({
    "1 属水；可保留1位，不建议连续重复。": "1 belongs to Water; keep one occurrence if desired and avoid consecutive repetition.",
    "1 属水；可作为个人锚点。": "1 belongs to Water; it can serve as a personal anchor.",
    "2 属土；可保留1位，不建议连续重复。": "2 belongs to Earth; keep one occurrence if desired and avoid consecutive repetition.",
    "2 属土；可作为个人锚点。": "2 belongs to Earth; it can serve as a personal anchor.",
    "3 属木；可保留1位，不建议连续重复。": "3 belongs to Wood; keep one occurrence if desired and avoid consecutive repetition.",
    "3 属木；可作为个人锚点。": "3 belongs to Wood; it can serve as a personal anchor.",
    "4 属木；可保留1位，不建议连续重复。": "4 belongs to Wood; keep one occurrence if desired and avoid consecutive repetition.",
    "4 属木；可作为个人锚点。": "4 belongs to Wood; it can serve as a personal anchor.",
    "5 属土；可保留1位，不建议连续重复。": "5 belongs to Earth; keep one occurrence if desired and avoid consecutive repetition.",
    "5 属土；可作为个人锚点。": "5 belongs to Earth; it can serve as a personal anchor.",
    "6 属金；可保留1位，不建议连续重复。": "6 belongs to Metal; keep one occurrence if desired and avoid consecutive repetition.",
    "6 属金；可作为个人锚点。": "6 belongs to Metal; it can serve as a personal anchor.",
    "7 属金；可保留1位，不建议连续重复。": "7 belongs to Metal; keep one occurrence if desired and avoid consecutive repetition.",
    "7 属金；可作为个人锚点。": "7 belongs to Metal; it can serve as a personal anchor.",
    "8 属土；可保留1位，不建议连续重复。": "8 belongs to Earth; keep one occurrence if desired and avoid consecutive repetition.",
    "8 属土；可作为个人锚点。": "8 belongs to Earth; it can serve as a personal anchor.",
    "9 属火；可保留1位，不建议连续重复。": "9 belongs to Fire; keep one occurrence if desired and avoid consecutive repetition.",
    "9 属火；可作为个人锚点。": "9 belongs to Fire; it can serve as a personal anchor.",
  }),
  "reduceNumbersBlock": Object.freeze({
    "—\n（—）": "—\n(—)",
    "1\n（水）": "1\n(Water)",
    "2、5、8\n（土）": "2、5、8\n(Earth)",
    "3、4\n（木）": "3、4\n(Wood)",
    "6、7\n（金）": "6、7\n(Metal)",
    "9\n（火）": "9\n(Fire)",
  }),
  "reduceRelation": Object.freeze({
    "—克—；与当前补强方向相逆，因此建议避免过度集中。": "— controls —; this runs counter to the current strengthening direction, so avoid excessive concentration.",
    "火克金；与当前补强方向相逆，因此建议避免过度集中。": "Fire controls Metal; this runs counter to the current strengthening direction, so avoid excessive concentration.",
    "金克木；与当前补强方向相逆，因此建议避免过度集中。": "Metal controls Wood; this runs counter to the current strengthening direction, so avoid excessive concentration.",
    "木克土；与当前补强方向相逆，因此建议避免过度集中。": "Wood controls Earth; this runs counter to the current strengthening direction, so avoid excessive concentration.",
    "水克火；与当前补强方向相逆，因此建议避免过度集中。": "Water controls Fire; this runs counter to the current strengthening direction, so avoid excessive concentration.",
    "土克水；与当前补强方向相逆，因此建议避免过度集中。": "Earth controls Water; this runs counter to the current strengthening direction, so avoid excessive concentration.",
  }),
  "lifeNumberOverlap": Object.freeze({
    "生命数字 1 不在少用组，可正常作为辅助识别。": "Life Number 1 is not in the reduced-use group and may be used normally as a supporting identifier.",
    "生命数字 1 也属水。它不是禁用数字，可保留1位作为个人识别，但不建议形成重复组合。": "Life Number 1 also belongs to Water. It is not prohibited; one occurrence may be retained for personal identification, but repeated combinations are not recommended.",
    "生命数字 2 不在少用组，可正常作为辅助识别。": "Life Number 2 is not in the reduced-use group and may be used normally as a supporting identifier.",
    "生命数字 2 也属土。它不是禁用数字，可保留1位作为个人识别，但不建议形成重复组合。": "Life Number 2 also belongs to Earth. It is not prohibited; one occurrence may be retained for personal identification, but repeated combinations are not recommended.",
    "生命数字 3 不在少用组，可正常作为辅助识别。": "Life Number 3 is not in the reduced-use group and may be used normally as a supporting identifier.",
    "生命数字 3 也属木。它不是禁用数字，可保留1位作为个人识别，但不建议形成重复组合。": "Life Number 3 also belongs to Wood. It is not prohibited; one occurrence may be retained for personal identification, but repeated combinations are not recommended.",
    "生命数字 4 不在少用组，可正常作为辅助识别。": "Life Number 4 is not in the reduced-use group and may be used normally as a supporting identifier.",
    "生命数字 4 也属木。它不是禁用数字，可保留1位作为个人识别，但不建议形成重复组合。": "Life Number 4 also belongs to Wood. It is not prohibited; one occurrence may be retained for personal identification, but repeated combinations are not recommended.",
    "生命数字 5 不在少用组，可正常作为辅助识别。": "Life Number 5 is not in the reduced-use group and may be used normally as a supporting identifier.",
    "生命数字 5 也属土。它不是禁用数字，可保留1位作为个人识别，但不建议形成重复组合。": "Life Number 5 also belongs to Earth. It is not prohibited; one occurrence may be retained for personal identification, but repeated combinations are not recommended.",
    "生命数字 6 不在少用组，可正常作为辅助识别。": "Life Number 6 is not in the reduced-use group and may be used normally as a supporting identifier.",
    "生命数字 6 也属金。它不是禁用数字，可保留1位作为个人识别，但不建议形成重复组合。": "Life Number 6 also belongs to Metal. It is not prohibited; one occurrence may be retained for personal identification, but repeated combinations are not recommended.",
    "生命数字 7 不在少用组，可正常作为辅助识别。": "Life Number 7 is not in the reduced-use group and may be used normally as a supporting identifier.",
    "生命数字 7 也属金。它不是禁用数字，可保留1位作为个人识别，但不建议形成重复组合。": "Life Number 7 also belongs to Metal. It is not prohibited; one occurrence may be retained for personal identification, but repeated combinations are not recommended.",
    "生命数字 8 不在少用组，可正常作为辅助识别。": "Life Number 8 is not in the reduced-use group and may be used normally as a supporting identifier.",
    "生命数字 8 也属土。它不是禁用数字，可保留1位作为个人识别，但不建议形成重复组合。": "Life Number 8 also belongs to Earth. It is not prohibited; one occurrence may be retained for personal identification, but repeated combinations are not recommended.",
    "生命数字 9 不在少用组，可正常作为辅助识别。": "Life Number 9 is not in the reduced-use group and may be used normally as a supporting identifier.",
    "生命数字 9 也属火。它不是禁用数字，可保留1位作为个人识别，但不建议形成重复组合。": "Life Number 9 also belongs to Fire. It is not prohibited; one occurrence may be retained for personal identification, but repeated combinations are not recommended.",
  }),
  "reduceBoundary": Object.freeze({
    "少用 — 指避免连续、密集或占据主要位置；并非绝对禁用，也不代表吉凶保证。": "Using — less often means avoiding consecutive, dense, or dominant placement; it is not an absolute prohibition and does not imply a guarantee of good or bad fortune.",
    "少用 1 指避免连续、密集或占据主要位置；并非绝对禁用，也不代表吉凶保证。": "Using 1 less often means avoiding consecutive, dense, or dominant placement; it is not an absolute prohibition and does not imply a guarantee of good or bad fortune.",
    "少用 2、5、8 指避免连续、密集或占据主要位置；并非绝对禁用，也不代表吉凶保证。": "Using 2、5、8 less often means avoiding consecutive, dense, or dominant placement; it is not an absolute prohibition and does not imply a guarantee of good or bad fortune.",
    "少用 3、4 指避免连续、密集或占据主要位置；并非绝对禁用，也不代表吉凶保证。": "Using 3、4 less often means avoiding consecutive, dense, or dominant placement; it is not an absolute prohibition and does not imply a guarantee of good or bad fortune.",
    "少用 6、7 指避免连续、密集或占据主要位置；并非绝对禁用，也不代表吉凶保证。": "Using 6、7 less often means avoiding consecutive, dense, or dominant placement; it is not an absolute prohibition and does not imply a guarantee of good or bad fortune.",
    "少用 9 指避免连续、密集或占据主要位置；并非绝对禁用，也不代表吉凶保证。": "Using 9 less often means avoiding consecutive, dense, or dominant placement; it is not an absolute prohibition and does not imply a guarantee of good or bad fortune.",
  }),
  "mobileAdvice": Object.freeze({
    "若有多个资费、信号与易记程度相近的选项，优先让 — 出现在较重要位置；可用 — 辅助。": "When multiple options are similar in plan cost, signal quality, and memorability, prefer — in more important positions; — can be used as support.",
    "若有多个资费、信号与易记程度相近的选项，优先让 1 出现在较重要位置；可用 6、7 辅助。": "When multiple options are similar in plan cost, signal quality, and memorability, prefer 1 in more important positions; 6、7 can be used as support.",
    "若有多个资费、信号与易记程度相近的选项，优先让 2、5、8 出现在较重要位置；可用 9 辅助。": "When multiple options are similar in plan cost, signal quality, and memorability, prefer 2、5、8 in more important positions; 9 can be used as support.",
    "若有多个资费、信号与易记程度相近的选项，优先让 3、4 出现在较重要位置；可用 1 辅助。": "When multiple options are similar in plan cost, signal quality, and memorability, prefer 3、4 in more important positions; 1 can be used as support.",
    "若有多个资费、信号与易记程度相近的选项，优先让 6、7 出现在较重要位置；可用 2、5、8 辅助。": "When multiple options are similar in plan cost, signal quality, and memorability, prefer 6、7 in more important positions; 2、5、8 can be used as support.",
    "若有多个资费、信号与易记程度相近的选项，优先让 9 出现在较重要位置；可用 3、4 辅助。": "When multiple options are similar in plan cost, signal quality, and memorability, prefer 9 in more important positions; 3、4 can be used as support.",
  }),
  "vehicleAdvice": Object.freeze({
    "先看合法性、价格与辨识度；条件相近时，以 — 为主体，避免 — 过度重复。": "Consider legality, price, and recognizability first; when conditions are similar, use — as the primary preference and avoid excessive repetition of —.",
    "先看合法性、价格与辨识度；条件相近时，以 1 为主体，避免 2、5、8 过度重复。": "Consider legality, price, and recognizability first; when conditions are similar, use 1 as the primary preference and avoid excessive repetition of 2、5、8.",
    "先看合法性、价格与辨识度；条件相近时，以 2、5、8 为主体，避免 3、4 过度重复。": "Consider legality, price, and recognizability first; when conditions are similar, use 2、5、8 as the primary preference and avoid excessive repetition of 3、4.",
    "先看合法性、价格与辨识度；条件相近时，以 3、4 为主体，避免 6、7 过度重复。": "Consider legality, price, and recognizability first; when conditions are similar, use 3、4 as the primary preference and avoid excessive repetition of 6、7.",
    "先看合法性、价格与辨识度；条件相近时，以 6、7 为主体，避免 9 过度重复。": "Consider legality, price, and recognizability first; when conditions are similar, use 6、7 as the primary preference and avoid excessive repetition of 9.",
    "先看合法性、价格与辨识度；条件相近时，以 9 为主体，避免 1 过度重复。": "Consider legality, price, and recognizability first; when conditions are similar, use 9 as the primary preference and avoid excessive repetition of 1.",
  }),
  "doorAdvice": Object.freeze({
    "不能选择时无需勉强；可选择时，把 — 作为次级偏好，0 视为中性占位。": "There is no need to force a choice when options are limited; when a choice is available, use — as a secondary preference, with 0 treated as a neutral placeholder.",
    "不能选择时无需勉强；可选择时，把 1 作为次级偏好，0 视为中性占位。": "There is no need to force a choice when options are limited; when a choice is available, use 1 as a secondary preference, with 0 treated as a neutral placeholder.",
    "不能选择时无需勉强；可选择时，把 2、5、8 作为次级偏好，0 视为中性占位。": "There is no need to force a choice when options are limited; when a choice is available, use 2、5、8 as a secondary preference, with 0 treated as a neutral placeholder.",
    "不能选择时无需勉强；可选择时，把 3、4 作为次级偏好，0 视为中性占位。": "There is no need to force a choice when options are limited; when a choice is available, use 3、4 as a secondary preference, with 0 treated as a neutral placeholder.",
    "不能选择时无需勉强；可选择时，把 6、7 作为次级偏好，0 视为中性占位。": "There is no need to force a choice when options are limited; when a choice is available, use 6、7 as a secondary preference, with 0 treated as a neutral placeholder.",
    "不能选择时无需勉强；可选择时，把 9 作为次级偏好，0 视为中性占位。": "There is no need to force a choice when options are limited; when a choice is available, use 9 as a secondary preference, with 0 treated as a neutral placeholder.",
  }),
  "accountAdvice": Object.freeze({
    "以安全、隐私与易记为先；可保留生命数字 1 作为个人锚点，但不应降低账号安全性。": "Prioritize security, privacy, and memorability; Life Number 1 may be retained as a personal anchor, but account security should not be weakened.",
    "以安全、隐私与易记为先；可保留生命数字 2 作为个人锚点，但不应降低账号安全性。": "Prioritize security, privacy, and memorability; Life Number 2 may be retained as a personal anchor, but account security should not be weakened.",
    "以安全、隐私与易记为先；可保留生命数字 3 作为个人锚点，但不应降低账号安全性。": "Prioritize security, privacy, and memorability; Life Number 3 may be retained as a personal anchor, but account security should not be weakened.",
    "以安全、隐私与易记为先；可保留生命数字 4 作为个人锚点，但不应降低账号安全性。": "Prioritize security, privacy, and memorability; Life Number 4 may be retained as a personal anchor, but account security should not be weakened.",
    "以安全、隐私与易记为先；可保留生命数字 5 作为个人锚点，但不应降低账号安全性。": "Prioritize security, privacy, and memorability; Life Number 5 may be retained as a personal anchor, but account security should not be weakened.",
    "以安全、隐私与易记为先；可保留生命数字 6 作为个人锚点，但不应降低账号安全性。": "Prioritize security, privacy, and memorability; Life Number 6 may be retained as a personal anchor, but account security should not be weakened.",
    "以安全、隐私与易记为先；可保留生命数字 7 作为个人锚点，但不应降低账号安全性。": "Prioritize security, privacy, and memorability; Life Number 7 may be retained as a personal anchor, but account security should not be weakened.",
    "以安全、隐私与易记为先；可保留生命数字 8 作为个人锚点，但不应降低账号安全性。": "Prioritize security, privacy, and memorability; Life Number 8 may be retained as a personal anchor, but account security should not be weakened.",
    "以安全、隐私与易记为先；可保留生命数字 9 作为个人锚点，但不应降低账号安全性。": "Prioritize security, privacy, and memorability; Life Number 9 may be retained as a personal anchor, but account security should not be weakened.",
  }),
});

export const NUMBER_ADVICE_EXACT_FIELDS = Object.freeze([
  "elementMeaning",
  "lifeNumberElement",
  "lifeNumberSummary",
  "overallRelation",
  "boundaryHint",
  "coreNumbersBlock",
  "auxNumbersBlock",
  "lifeNumberBlock",
  "priorityOrder",
  "reinforcementLogic",
  "lifeNumberUsage",
  "reduceNumbersBlock",
  "reduceRelation",
  "lifeNumberOverlap",
  "reduceBoundary",
  "mobileAdvice",
  "vehicleAdvice",
  "doorAdvice",
  "accountAdvice"
]);

export function localizeNumberAdviceValue(
  locale,
  field,
  value,
) {
  if (typeof value !== "string") return value;
  if (locale !== "en") return value;

  const fieldCatalog = EN_BY_FIELD[field];

  if (!fieldCatalog) return value;

  return Object.prototype.hasOwnProperty.call(
    fieldCatalog,
    value,
  )
    ? fieldCatalog[value]
    : value;
}

export const __NUMBER_ADVICE_EXACT_EN_TEST_ONLY__ = EN_BY_FIELD;

/**
 * I18N-C3-D3 — Sheet24 r10RelationClass finite exact localization.
 *
 * Used only by verified Sheet25 cross-sheet presentation.
 * Number-group strings remain opaque and are not parsed or normalized.
 */

const NUMBER_RELATION_CLASS_EN = Object.freeze({
  "—": "—",
  "同向强化": "Same-direction reinforcement",
  "相生支持": "Generative support",
  "需要平衡": "Balance needed",
  "中性搭配": "Neutral pairing",
});

export function localizeNumberRelationClass(
  locale,
  value,
) {
  if (typeof value !== "string") return value;
  if (locale !== "en") return value;

  return Object.prototype.hasOwnProperty.call(
    NUMBER_RELATION_CLASS_EN,
    value,
  )
    ? NUMBER_RELATION_CLASS_EN[value]
    : value;
}

export const __NUMBER_RELATION_CLASS_EN_TEST_ONLY__ =
  NUMBER_RELATION_CLASS_EN;
